import React from 'react';
import {
  SHELF_AUDIT_HEIGHT_LIMITS,
  type ShelfAuditHeightLimit,
} from '@/shared/types/shelfAudit.types';

const HEIGHT_LIMIT_STORAGE_KEY = 'shelf-audit-height-limit';

const HEIGHT_LIMIT_OPTIONS: readonly {
  readonly id: ShelfAuditHeightLimit;
  readonly title: string;
  readonly detail: string;
}[] = [
  { id: SHELF_AUDIT_HEIGHT_LIMITS.low, title: 'Low Boxes', detail: '(Height 1-4)' },
  { id: SHELF_AUDIT_HEIGHT_LIMITS.high, title: 'High Boxes', detail: '(Height 5-6)' },
];

function isShelfAuditHeightLimit(value: string | null): value is ShelfAuditHeightLimit {
  return value === SHELF_AUDIT_HEIGHT_LIMITS.low || value === SHELF_AUDIT_HEIGHT_LIMITS.high;
}

export function readStoredShelfAuditHeightLimit(): ShelfAuditHeightLimit | null {
  try {
    const raw = sessionStorage.getItem(HEIGHT_LIMIT_STORAGE_KEY);
    return isShelfAuditHeightLimit(raw) ? raw : null;
  } catch {
    return null;
  }
}

export function storeShelfAuditHeightLimit(limit: ShelfAuditHeightLimit | null): void {
  try {
    if (limit == null) {
      sessionStorage.removeItem(HEIGHT_LIMIT_STORAGE_KEY);
      return;
    }
    sessionStorage.setItem(HEIGHT_LIMIT_STORAGE_KEY, limit);
  } catch {
    // sessionStorage can be unavailable in private browsing.
  }
}

interface ShelfAuditHeightLimitProps {
  readonly value: ShelfAuditHeightLimit | null;
  readonly onChange: (next: ShelfAuditHeightLimit | null) => void;
}

const ShelfAuditHeightLimit: React.FC<ShelfAuditHeightLimitProps> = ({ value, onChange }) => {
  return (
    <div className="sa-height-limit">
      <div className="sa-height-limit-label">Height limit (optional)</div>
      <div className="sa-height-limit-actions" role="group" aria-label="Height limit">
        {HEIGHT_LIMIT_OPTIONS.map((option) => {
          const selected = value === option.id;
          return (
            <button
              key={option.id}
              type="button"
              className={`dev-panel-button sa-height-limit-button${selected ? ' sa-filter-active' : ''}`}
              aria-pressed={selected}
              onClick={() => onChange(selected ? null : option.id)}
            >
              <span className="sa-height-limit-title">{option.title}</span>
              <span className="sa-height-limit-detail">{option.detail}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ShelfAuditHeightLimit;
